import SVG from 'svg.js';

export default class SquarePreloader
{
    constructor(target)
    {
      this.element = SVG(target).size('100%', '100%');
      this.group = this.element.group();
      this.rect = this.element.rect(30, 30).move(5, 5).attr({ fill: '#8d6eaa' });
      this.group.add(this.rect);
      this.group.animate(500, "<", 100).transform({ rotation : 90.0, relative : true }).loop();
      this.changeColor(['#8d6eaa', '#49a7f1', '#5fbe76'], 0);
      this.destroyed = false;
    }

    changeColor(colors, currentColor)
    {
      if(this.destroyed)
        return;

      if(currentColor >= colors.length)
        currentColor = 0;

      this.rect.animate(500, "<").fill(colors[currentColor]).after(() => this.changeColor(colors, currentColor + 1));
    }

    destroy()
    {
      this.destroyed = true;
      this.element.node.parentNode.removeChild(this.element.node);
    }
}



// WEBPACK FOOTER //
// ./src/components/Preloaders/SquarePreloader.js